/**
 * STANDARD slot Select options for picking list filters.
 * Local to DeliveryOrdersPicking — does not change DeliveryOrders filters.
 */
import { formatTime } from '../../../../lib/datetime'

export const buildStandardSlotOptions = (slots = []) =>
  (slots || [])
    .filter((slot) => slot.type === 'STANDARD')
    .map((slot) => ({
      text: `${formatTime(slot.startTime)} - ${formatTime(slot.endTime)}`,
      value: JSON.stringify({
        startTime: slot.startTime,
        endTime: slot.endTime,
      }),
    }))

export default buildStandardSlotOptions
